import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  fontTitleStyle: {
    fontSize: 16,
    fontWeight: 700,
    margin: 0,
  },
  fontDescriptionStyle: {
    fontSize: 14,
    fontWeight: 400,
    margin: 0,
  },
  card: {
    justifyContent: 'center',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  cardContainer: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    fontWeight: 400,
    border: '1px solid #D9D9D9',
    '& svg': {
      width: 16,
    },
    '& span': {
      gap: '8px',
    },
    '&:hover': {
      color: '#D9D9D9',
      backgroundColor: '#0D2772',
      opacity: 1,
      '& img': {
        color: '#D9D9D9',
      },
    },
  },
  icon: {
    width: 40,
    height: 40,
    padding: 10,
    borderRadius: '50%',
    backgroundColor: '#D9D9D9',
    display: 'inline-block',
  },
}));
